<script setup lang="ts">
  import tradutor from '../../../tradutors/rightnavbar'
  import { userStore } from '../../../stores/user'
  import { localeStore } from '../../../stores/locale'
  import IconeBds from 'assets/img/icone_BDS.png'
  import router from '../../../router'
  import { jwtStore } from '../../../stores/jwt'

  //Icones
  import Telegram from 'assets/img/telegramRed.webp'
  import Topfans from 'assets/img/topfansRed.webp'
  import Twitter from 'assets/img/twitterRed.webp'
  import Whatsapp from 'assets/img/whatsappRed.webp'
  //import Youtube from 'assets/img/youtubeRed.webp'

  import FlagUnitedStates from 'assets/img/Flag_of_the_United_States.webp'
  import FlagBrasil from 'assets/img/Flag_of_Brazil.webp'
  import { isMobile } from '../../../views/shared/utils/mobile'
  import { computed, ref, watch } from 'vue'

  const emits = defineEmits(['showMenuLateral', 'showModalSubscribePlans'])

  const storeUser = userStore()
  const storeJwt = jwtStore()

  const imgIcone = ref(IconeBds)
  const showLangMenu = ref(false)
  const icones = ref([
    { src: Telegram, link: 'https://t.me/belladasemanaoficial' },
    { src: Topfans, link: 'https://topfans.me/bella' },
    //{ src: Youtube, link: 'https://www.youtube.com/channel/UCAjpZH6H-Tqt5JI7F3dPeTA' },
    { src: Twitter, link: 'https://twitter.com/belladasemana' },
    { src: Whatsapp, link: 'https://chat.whatsapp.com/IS3rWOWDnLeIyNQbvDfGdq' }
  ])
  const langLinks = ref([
    {
      name: 'PT',
      fullName: 'Português',
      flag: FlagBrasil,
      lang: 'pt-br'
    },
    {
      name: 'EN',
      fullName: 'English',
      flag: FlagUnitedStates,
      lang: 'en'
    }
  ])
  const storeLocale = localeStore()
  const reactiveLocale = computed(() => storeLocale.locale)
  const reactiveisLoggedIn = computed(() => storeUser.isLoggedIn)
  
  const setIdLang = ref(reactiveLocale.value === "en" ? 1 : 0)
  
  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return tradutor.portugues
    } else {
      return tradutor.ingles
    }
  })

  watch(reactiveLocale, (val) => {
    setIdLang.value = val === 'en' ? 1 : 0
  })

  function closeMenu() {
    emits('showMenuLateral', false)
  }
  function redirect(name: string) {
    router.push({ name, params: { locale: reactiveLocale.value } })
  }

  function changeLang(locale: string) {
    showLangMenu.value = false
    storeLocale.setLocale(locale)

    let newUrl = router.currentRoute.value.fullPath
    reactiveLocale.value == 'pt-br'
      ? (newUrl = newUrl.replace(/en/, reactiveLocale.value))
      : (newUrl = newUrl.replace(/pt-br/, reactiveLocale.value))
    router.replace(newUrl)
  }
  async function logout() {
    closeMenu()
    storeJwt.jwtLogout()
    redirect('homePage')
  }
</script>
<template>
  <nav class="new_menu__nav">
    <div class="d-flex div-header">
      <div class="new_menu__header">
        <span v-if="reactiveisLoggedIn">
          {{ translate.menu.hello.toUpperCase() || '' }}
          , {{ storeUser.user.nickname ?? storeUser.user.name }}
        </span>
        <div v-else @click="redirect('AssineOptionsPage')">
          {{ translate.menu.subscribe.toUpperCase() || '' }}
          <font-awesome-icon v-if="!reactiveisLoggedIn"
            :icon="['fas', 'arrow-right']"
            size="md"
            style="margin-left: 12px;"
          />
        </div>
      </div>
      <div class="d-flex flex-fill align-items-center justify-content-center bg-red">
        <a
          @click.prevent="closeMenu"
          href="#"
          class="w-50 h-50 d-flex justify-content-center close-x"
          >x</a
        >
      </div>
    </div>

    <div class="new_menu__body">
      <ul class="new_menu__list">
        <li
          v-if="reactiveisLoggedIn"
          @click="redirect('MyAccountPage')"
          style="background-color: #eaeaea"
        >
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.myAccountLogado || '' }}
        </li>
        <li v-else @click="redirect('LoginPage')" style="background-color: #eaeaea">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.myAccount || '' }}
        </li>
        <li @click="redirect('AssineOptionsPage')" v-if="isMobile() && reactiveisLoggedIn">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ reactiveisLoggedIn ? translate.menu.subscribe2Login : translate.menu.subscribe2 || '' }}
        </li>
        <li v-if="reactiveisLoggedIn" @click="redirect('MyCreditsPage')">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.myCredits || '' }}
        </li>
        <li @click="redirect('ModelsPage')" class="d-xl-none d-block">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.modelos || '' }}
        </li>
        <li @click="redirect('FreeTourPage')" class="d-xl-none d-block">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.freetour || '' }}
        </li>
        <li @click="redirect('VideosPage')" class="d-xl-none d-block">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.videos || '' }}
        </li>
        <li @click="redirect('LivesPage')" class="d-xl-none d-block">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.lives || '' }}
        </li>
        <li @click="redirect('BlogsPage')">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.blog || '' }}
        </li>
        <li @click="redirect('ColumnsPage')">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.colums || '' }}
        </li>
        <li @click="redirect('EcardsPage')">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.ecards || '' }}
        </li>
        <li @click="redirect('BellaCloudPage')">
          <img :src="imgIcone" alt="Icone BDS" />
          {{ translate.menu.bellacloud || '' }}
        </li>
      </ul>
      <ul class="new_menu__list--util">
        <li class="footer_list" @click="redirect('AboutPage')">
          {{ translate.menu.sobre || '' }} <i class="icon-arrow-ios-right"></i>
        </li>
        <li class="footer_list" @click="redirect('ContactUsPage')">
          {{ translate.menu.contactUs || '' }} <i class="icon-arrow-ios-right"></i>
        </li>
        <li class="footer_list" v-if="isMobile">
          <!-- Languages -->

          <div class="language-nav-mobile dropdown">
            <a
              href="#"
              class="dropdown-toggle"
              id="language"
              data-toggle="dropdown"
              @click.prevent="showLangMenu = !showLangMenu"
            >
              <img :src="langLinks[setIdLang].flag" :alt="langLinks[setIdLang].fullName" />{{
                langLinks[setIdLang].fullName
              }}
            </a>
            <div class="dropdown-menu down-menu" :class="{ show: showLangMenu }" aria-labelledby="language">
              <a
                href="#"
                v-for="(link, i) in langLinks"
                :key="i"
                class="dropdown-item"
                @click.prevent="changeLang(link.lang)"
              >
                <img :src="link.flag" :alt="link.fullName" />
                <span class="language-label">{{ link.name }}</span>
              </a>
            </div>
          </div>
        </li>
        <li class="footer_list" v-if="reactiveisLoggedIn">
          <a href="#" class="logout" @click.prevent="logout"
            >{{ translate.menu.logout.toUpperCase() }}
          </a>
        </li>
      </ul>
      <!-- Social Links -->
      <ul class="social-box">
        <li v-for="(icon, index) in icones" :key="index">
          <a :href="icon.link" target="_blank"
            ><img :src="icon.src" alt="Social Link" width="25" height="25" class="icon-header"
          /></a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<style scoped lang="scss">
  .bm-burger-button {
    position: fixed;
    top: 26px;
    right: 18px !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 22px;
    height: 16px;
    z-index: 999;

    @media (min-width: 769px) {
      right: 43px !important;
    }
  }

  .bm-burger-bars {
    background-color: #373a47;
    border-radius: 25%;
  }

  .line-style {
    position: absolute;
    height: 3px;
    left: 0;
    right: 0;
  }

  .cross-style {
    position: absolute;
    top: 12px;
    right: 2px;
    cursor: pointer;
  }

  .bm-cross {
    background: #bdc3c7;
  }

  .bm-cross-button {
    height: 30px;
    width: 30px;
    right: 4px;
  }

  .bm-menu {
    height: 100vh;
    /* 100% Full-height */
    width: 0;
    /* 0 width - change this with JavaScript */
    position: fixed;
    /* Stay in place */
    z-index: 1000;
    /* Stay on top */
    top: 0;
    left: 0;
    background-color: rgb(63, 63, 65);
    /* Black*/
    overflow-x: hidden;
    /* Disable horizontal scroll */
    padding-top: 0;
    /* Place content 60px from the top */
    transition: 0.5s;
    /*0.5 second transition effect to slide in the sidenav*/
  }

  .bm-overlay {
    background: rgba(0, 0, 0, 0.6);
  }

  .bm-item-list {
    color: #b8b7ad;
    margin-left: 0;
    font-size: 20px;
    height: 100%;
  }

  .bm-item-list > * {
    display: block;
    text-decoration: none;
    padding: 0;
  }

  .bm-item-list > * > span {
    margin-left: 10px;
    font-weight: 700;
    color: white;
  }

  .new_menu__header {
    color: #fff;
    height: 65px;
    cursor: pointer;
  }

  .new_menu__header div {
    height: 24px;
    color: #ffffff;
    font-family: 'Bebas-Neue';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 29px;
    left: -55px;
  }

  .new_menu__header span {
    height: 24px;
    color: #ffffff;
    font-family: 'Bebas-Neue';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 29px;
    left: -55px;
  }

  .new_menu__list img {
    width: 24px;
    height: 24px;
    margin-right: 0px;
    object-fit: cover;
  }

  .new_menu__list li {
    height: 29px;
    color: #000000;
    font-family: 'Exo-2';
    font-size: 20px;
    letter-spacing: 0;
    line-height: 29px;
    background: whitesmoke !important;
    cursor: pointer;    
  }

  .footer_list {
    height: 17px;
    color: #000000;
    font-family: 'Exo-2';
    font-size: 13px;
    letter-spacing: 0;
    line-height: 17px;
    padding: 10px 0px;
  }

  .new_menu__list--util li a {
    color: #000000;
  }
  .footer_list i[class*='icon-']:before {
    color: #999 !important;
  }

  .new_menu__list--util li {
    cursor: pointer;
    margin-bottom: 15px;
  }

  .flex-fill {
    width: 104px;
  }

  .new_menu__nav {
    height: unset;
    box-shadow: rgba(0, 0, 0, 0.66) 0px 22px 70px 100000px;
    border-radius: 20px;    
  }

  .language-nav-mobile {
    width: 60px;
    height: 24px;
    margin-right: 30px;
  }

  .language-nav-mobile a img {
    border-radius: 50%;
    width: 22px;
    height: 22px;
    object-fit: cover;
    top: -2px;
  }
  .language-nav-mobile a {
    font-family: 'Exo-2';
    vertical-align: unset;
    top: 0px;
  }

  .language-nav-mobile .dropdown-toggle:after {
    top: -1px;
    color: rgba(0, 0, 0, 0.5);
  }

  .language-nav-mobile .dropdown-menu.show {
    background: #fff;
  }

  .new_menu__body {
    padding: 0px 0px;
  }

  .new_menu__list li {
    margin-bottom: 0px;
    height: 45px;
    padding-left: 20px;
    padding-top: 10px;
  }

  .new_menu__list--util {
    padding-left: 20px;
    margin-bottom: 15px;    
  }

  .social-box {
    padding-left: 20px;
    padding-bottom: 25px;
    padding-top: 20px;    
    height: 40px;
  }

  .new_menu__list {
    margin-bottom: 0px;
    width: 80%;
  }

  .bg-red {
    background-color: #b20000;
  }

  .close-x {
    top: -14px; 
    font-size: 35px; 
    font-weight: 900; 
    color: #fff
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .new_menu__list li {
      height: 22px;
      color: #000000;
      font-family: 'Exo-2';
      font-size: 16px;
      letter-spacing: 0;
      line-height: 22px;
    }

    .new_menu__list img {
      width: 17px;
      height: 18px;
    }

    .div-header {
      height: 65px;
    }

    .new_menu__header {
      height: 65px;
    }

    .flex-fill {
      width: 66px;
    }

    .new_menu__list li {
      margin-bottom: 0px;
      height: 35px;
      padding-left: 20px;
      padding-top: 5px;
    }

    .close-x {
      top: -20px; 
    }

    .new_menu__header div, .new_menu__header span {
      left: unset;
    }    


  }
</style>
